<template>
  <div id="DashbordStaffView">
   <dashboard/>
  </div>
</template>

<script>

// import axios from "axios";
import dashboard from '../../components/staff/dashboard.vue';
export default {
  components: { dashboard },
  name: "DashbordStaffView",
  data() {
    return {
     
    };
  },

};
</script>

<style scoped>

</style>
